
  import { defineComponent,ref } from 'vue';
  import type { UploadFile } from 'element-plus'
  export default defineComponent({
    name:'uploadFileDialog',
    props:{
      show:{
        type:Boolean,
        default:false
      },
    },
    emits:['closeDialog','submit'],
    setup(props,ctx){
      let fileList:any = ref([])
      function closeDialog():void{
        ctx.emit('closeDialog')
      }
      function submit():void{
        ctx.emit('submit',fileList.value[0])
      }
      function changeFile(UploadFile:any):void{
        fileList.value = [UploadFile]
      }
      return {
        fileList,
        closeDialog,
        submit,
        changeFile
      }
    }
  })
